// Where to go after signing in. Only internal CV-access and applicants links
// are kept, so a crafted link can't send someone elsewhere.
const KEY = 'postLoginPath';
const SAFE_PATHS = [
  /^\/cv-access\?cv=[A-Za-z0-9]+$/,
  /^\/job-postings\/[A-Za-z0-9-]+\/applicants$/,
];

export const setPostLoginPath = (path) => {
  try {
    sessionStorage.setItem(KEY, path);
  } catch {
    // storage blocked: fall back to the dashboard
  }
};

export const takePostLoginPath = () => {
  try {
    const path = sessionStorage.getItem(KEY) || '';
    sessionStorage.removeItem(KEY);
    return SAFE_PATHS.some((re) => re.test(path)) ? path : '/dashboard';
  } catch {
    return '/dashboard';
  }
};
